import React, {useState, useEffect} from 'react'
import './Contract.css'
import { useNavigate } from 'react-router-dom';
import CloseButton from 'react-bootstrap/CloseButton';
import ToggleButton from 'react-bootstrap/ToggleButton';
import ToggleButtonGroup from 'react-bootstrap/ToggleButtonGroup';
import Button from 'react-bootstrap/Button';
import ListOfContract from './adminComponents/ListOfContract'

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import {Container}  from 'react-bootstrap';
import { useParams } from 'react-router';
import Toast from 'react-bootstrap/Toast';
import fetchData from '../../function/fetchData';

// Různé smlouvy
import ContractMain from './adminComponents/ContractMain';
import ContractProvize from './adminComponents/ContractProvize';
import ContractCodex from './adminComponents/ContractCodex';
import ContractualTransportation from './adminComponents/ContractualTransportation'



// MAIN
const Contract = ({server}) => {
    const {tokenOfContract} = useParams()
    const [data, setData] = useState(null)
    const [alreadySigned , setAlreadySigned] = useState(false)
    const [showMessage, setShowMessage] = useState(false)

    const navigate = useNavigate();
    const [type, setType] = useState("list")

    // TOKEN
    const [token, setToken] = useState(null)

    useEffect( () => {
        const adminToken = localStorage.getItem('driverToken');
        if(adminToken && !tokenOfContract) {
          setToken(adminToken)
        }
    }, [])

    // POKUD nema admin token a má token of contract, stáhne si danou smlouvu
    useEffect( ()=> {
        if(tokenOfContract){
            fetchData(server + "api2/contractController.php" , {
                action: 'GET',
                type: type,
                tokenOfContract: tokenOfContract,
            }).then( (res) => {

                if(res.status === "OK"){
                    setData( JSON.parse(res.payload.form_data_json) )
                    setType(res.payload.type)
                    if(res.payload.signature){
                        setAlreadySigned(true)
                        
                    }
                }
  
            })
        }
    },[])

    // Done
    const handleDone = () => {
        setAlreadySigned(true)
        setShowMessage('Smlouva uložena, děkujeme')
    }



    return (
        <div style={{paddingBottom: 59}}>
         {/* Zpráva */}
         {showMessage &&
            <Toast style={{position: 'fixed', left: 10, top: 10 , background:'#eee'}} onClick={()=> setShowMessage(false)}>
                <Toast.Header>
                    <img src="holder.js/20x20?text=%20" className="rounded me-2" alt="" />
                    <strong className="me-auto">Upozornění</strong>
    
                </Toast.Header>
                <Toast.Body>{showMessage}</Toast.Body>
            </Toast>
         }

            
            {/* TOP */}
            {token &&  <div className='top'>
                            <div style={{display:'flex', gap: 10, alignItems: 'center'}}>
                                <h2>Smlouvy</h2>
                            </div>
                            {/* Tlačítka */}
                            <ToggleButtonGroup type="radio" name="options" defaultValue={1} size={'sm'} > 
            
                                <ToggleButton id="tbg-radio-1" value={1} onClick={()=> setType('list')}>
                                    Seznam smluv
                                </ToggleButton>

                                <ToggleButton id="tbg-radio-2" value={2} onClick={()=> setType('contractMain')}>
                                    Dohoda o pracovní činnosti
                                </ToggleButton>

                                <ToggleButton id="tbg-radio-3" value={3} onClick={()=> setType('contractProvize')}>
                                    Smlouva o zprostředkování zakázek
                                </ToggleButton>

                                <ToggleButton id="tbg-radio-4" value={4} onClick={()=> setType('contractCodex')}>
                                Kodex pokut
                                </ToggleButton>

                                <ToggleButton id="tbg-radio-4" value={4} onClick={()=> setType('contractualTransportation')}>
                                Smluvní přeprava
                                </ToggleButton>

                            </ToggleButtonGroup>

                            <CloseButton onClick={()=> navigate('/admin') }/>
                        </div>
            }
           

            {/* BODY */}

        
            {/* Smlouvy */}
            { type === "list" && <ListOfContract server={server} token={token}/>}
            { type === "contractMain" && (data || token) && <ContractMain server={server} token={token} data={data} tokenOfContract={tokenOfContract} alreadySigned={alreadySigned} handleDone={handleDone} setShowMessage={setShowMessage}/> }  
            { type === "contractProvize" && (data || token) && <ContractProvize server={server} token={token} data={data} tokenOfContract={tokenOfContract} alreadySigned={alreadySigned} handleDone={handleDone} setShowMessage={setShowMessage}/>  }
            { type === "contractCodex" && (data || token) && <ContractCodex server={server} token={token} data={data} tokenOfContract={tokenOfContract} alreadySigned={alreadySigned} handleDone={handleDone} setShowMessage={setShowMessage}/>  }
            { type === "contractualTransportation" && (data || token) && <ContractualTransportation server={server} token={token} data={data} tokenOfContract={tokenOfContract} alreadySigned={alreadySigned} handleDone={handleDone} setShowMessage={setShowMessage}/>  }
        </div>
    )
}

export default Contract
